<div class="content">
    <h2 mat-dialog-title>Toevoegen Instrument (barcode)</h2>
    <mat-dialog-content>
        <form [formGroup]="InstrumentFormGroup">
            <br>
            <mg-simple-form-row>
                <span mg-colspan-3>
                    <mat-form-field pd-size-10>
                        <input type="text" id="barcode" placeholder="Barcode Instrument" formControlName="barcode" matInput class="login-form-field" (keydown.enter)="getBarcode($event.target.value)">
                    </mat-form-field>
                    &nbsp;
                    <mat-form-field pd-size-24>
                        <mg-autocomplete #instrumentAutocomplete placeholder="Instrument" formControlName="instrument" [disabled]="true" [displayFn]="instrumentDisplayFn" [getData]="getInstrumentDataSource"></mg-autocomplete>
                    </mat-form-field>
                </span>
            </mg-simple-form-row>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div style="float:left; text-align: left; width: 99%;">
            <div style="float:left; text-align: left; width: 50%;">
                <button type="button" mat-button color="primary" mat-dialog-close>Sluiten</button>
            </div>
            <div style="float:left; text-align: right; width: 50%;">
                <button type="button"id="savebutton" mat-button color="primary" [disabled]="isDisabled" (click)="SaveAndAddBarcode()">Opslaan</button>
            </div>
        </div>
    </mat-dialog-actions>
</div>

